import Section from "@/components/site/Section";
import { Reveal } from "@/components/site/Reveal";
import { Overline } from "@/components/site/primitives";
import PartnershipForm from "@/components/site/PartnershipForm";
import { PARTNER_TYPES } from "@/lib/content";

export default function PartnersSection() {
  return (
    <Section id="partners" bg="surface" data-testid="partners-section">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <Overline>For Partners</Overline>
            <h2 className="mt-5 font-display text-4xl font-light uppercase leading-[0.95] tracking-tight md:text-5xl">
              Build the better stop with us.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-white/55">
              RestPower is exploring opportunities with property owners, developers, charging providers,
              utilities, municipalities, travel partners, investors, and infrastructure organizations
              interested in shaping the next generation of roadside travel.
            </p>
            <div className="mt-8 flex flex-wrap gap-2.5">
              {PARTNER_TYPES.map((t) => (
                <span key={t} className="rounded-full border border-white/12 bg-rp-card px-3.5 py-2 font-mono text-[11px] uppercase tracking-[0.1em] text-white/60">
                  {t}
                </span>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.08} className="rounded-3xl border border-white/10 bg-rp-card p-7 md:p-10">
            <h3 className="font-display text-2xl font-medium tracking-tight text-white">Start the conversation</h3>
            <p className="mt-2 text-sm text-white/50">Tell us about the opportunity and we'll be in touch.</p>
            <div className="mt-8">
              <PartnershipForm />
            </div>
          </Reveal>
        </div>
      </div>
    </Section>
  );
}
